import React from 'react';
import { LargeBlockQuoteContentModel } from 'src/api/models/LargeBlockQuote';
import { LargeBlockQuoteAvatar } from './BlockQuoteLarge.styles';
import { GatsbyImage } from 'gatsby-plugin-image';
import Grid from 'atoms/Layout/Grid/Grid';
import Typography from 'atoms/Typography/Typography';
import Stack from 'atoms/Layout/Stack/Stack';

const BlockQuoteLarge = ({
  quote,
  authorName,
  authorTitle,
  authorAvatar,
}: LargeBlockQuoteContentModel): JSX.Element => {
  const quotedText = quote.replace(/"/g, '').replace(/“/g, '').replace(/”/g, '');

  return (
    <Grid
      totalColumns={1}
      gap='spacing-3xl'
      paddingBottom='spacing-4xl'
    >
      <Typography
        text={`“${quotedText}”`}
        size='xs'
        type='heading'
        textAlign='center'
        color='text-primary'
        fontWeight='font-weight-semibold'
      />
      <Stack
        direction='column'
        gap='spacing-lg'
      >
        <LargeBlockQuoteAvatar>
          <GatsbyImage
            image={authorAvatar.gatsbyImageData}
            alt={authorName}
          />
        </LargeBlockQuoteAvatar>
        <Stack
          direction='column'
          gap='spacing-xxs'
        >
          <Typography
            text={authorName}
            size='md'
            type='paragraph'
            textAlign='center'
            color='text-primary'
            fontWeight='font-weight-semibold'
          />
          <Typography
            text={authorTitle}
            size='md'
            type='paragraph'
            textAlign='center'
            color='text-primary'
          />
        </Stack>
      </Stack>
    </Grid>
  );
};

export default BlockQuoteLarge;
